import { render } from "./evidence_vault.html?vue&type=template&id=107fe7ca&external"
import script from "./evidence_vault.js?vue&type=script&lang=js&external"
export * from "./evidence_vault.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__